export const CourierId = {
  "WALKING": 0,
  "CUT_CATS": 1,
  "TOOKAN": 4,
  "POSTMATES": 5,
  "DOORDASH": 6,
  "SKIPCART": 7,
  "REEF": 8,
  "RELAY": 9
}